import { render, staticRenderFns } from "./upload-imageTwoOne-16-9.vue?vue&type=template&id=46ae44e5&scoped=true"
import script from "./upload-imageTwoOne-16-9.vue?vue&type=script&lang=ts"
export * from "./upload-imageTwoOne-16-9.vue?vue&type=script&lang=ts"
import style0 from "./upload-imageTwoOne-16-9.vue?vue&type=style&index=0&id=46ae44e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae44e5",
  null
  
)

export default component.exports